import { METHOD, request } from "./../../utils/request";
import { Interests } from "./../api";

async function getAll(params) {
  return request(Interests.getAll, METHOD.GET, params);
}
async function getDetails(params) {
  return request(Interests.getDetails, METHOD.GET, params);
}
async function getDialog(params) {
  return request(Interests.getDialog, METHOD.GET, params);
}

async function add(data) {
  return request(Interests.add, METHOD.POST, data);
}
async function update(data) {
  return request(Interests.update, METHOD.POST, data);
}

async function changeActivationType(data) {
  return request(Interests.changeActivationType, METHOD.POST, data);
}

async function finalDelete(data) {
  return request(Interests.finalDelete, METHOD.POST, data);
}
async function deleteImage(data) {
  return request(Interests.deleteImage, METHOD.POST, data);
}

export default {
  getAll,
  getDetails,
  getDialog,
  add,
  update,
  changeActivationType,
  finalDelete,
  deleteImage,
};
